import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import {
    mediateSelectedListInfoDependent,
    mediateGetTasksRequester,
} from 'mediators';
import { RequestTasksSignal } from 'presentation/events';
import { useSelector, useDispatch } from 'react-redux';
import { Header } from './Header';
import { DailyCashflow } from './DailyCashflow';
import { EntryEditPage } from './EntryEditPage';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: { backgroundColor: '#f8fafc', height: '100%', display: 'flex', flexDirection: 'column' },
        content: { flex: 1, overflow: 'hidden', minHeight: 0 },
    })
);

export const Todos = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const list: any = useSelector(mediateSelectedListInfoDependent);
    const [requestTasksSignal] = useState(new RequestTasksSignal());
    const { path } = useRouteMatch();

    useEffect(() => {
        return mediateGetTasksRequester(requestTasksSignal, dispatch).destroy;
    }, [requestTasksSignal, dispatch]);

    useEffect(() => {
        list && requestTasksSignal.dispatch(list);
    }, [list, requestTasksSignal]);

    if (!list) return <></>;

    return (
        <Box className={classes.root}>
            <Header listID={list.id} />
            <Box className={classes.content}>
                <Switch>
                    <Route path={`${path}/:id`}>
                        <EntryEditPage />
                    </Route>
                    <Route>
                        <DailyCashflow />
                    </Route>
                </Switch>
            </Box>
        </Box>
    );
};
